const Section4 = () => {
  return (
    <section className='bg-white w-full min-h-[928px] space-y-4 mt-3 z-20 py-16 px-3 md:px-8 lg:px-12'>
      <div className='flex flex-col mt-4 lg:flex-row items-center justify-between'>
        {/* Left Section */}
        <div className='w-full lg:w-1/2 text-center lg:text-left space-y-4 px-4 md:px-8 lg:ml-20'>
          {/* Small Heading */}
          <div className='flex items-center justify-center lg:justify-start space-x-2'>
            <img
              src='./sphere.png'
              alt='About Us'
              className='h-[14px] w-[18px] md:h-[17px] md:w-[23px]'
            />
            <h2 className='text-base md:text-sm font-normal font-raleway text-orange-400'>
              Our status Values
            </h2>
          </div>

          {/* Main Title */}
          <h3 className='text-2xl md:text-4xl lg:text-5xl font-Anton text-orange-900 leading-snug md:leading-tight'>
            Creating a Community <br className='hidden md:block' />
            of life-long <span className='text-orange-400'>Learners</span>
          </h3>

          {/* Subtitle */}
          <h4 className='text-sm md:text-base font-medium font-raleway text-gray-800 leading-snug'>
            Providing professional growth by supporting FCHWS in their career
            development, enhancing their skills and confidence
          </h4>

          {/* Levels stacked */}
          <div className='relative w-full max-w-[648px] h-auto mt-6 space-y-6 mx-auto lg:mx-0'>
            <img
              src='./Level 2.png'
              alt='Thumb 5'
              className='w-full h-[60px] md:h-[70px] lg:h-[81px] object-cover'
            />
            <img
              src='./level 3.png'
              alt='Thumb 5'
              className='w-full h-[60px] md:h-[70px] lg:h-[81px] object-cover'
            />
            <img
              src='./Level 4.png'
              alt='Thumb 5'
              className='w-full h-[60px] md:h-[70px] lg:h-[81px] object-cover'
            />
            <img
              src='./level 5.png'
              alt='Thumb 5'
              className='w-full h-[60px] md:h-[70px] lg:h-[81px] object-cover'
            />
          </div>
        </div>

        {/* Right Section */}
        <div className='w-full lg:w-1/2 relative mt-10 lg:mt-0 flex justify-center items-start'>
          <div className='relative w-[280px] md:w-[400px] lg:w-[588px] h-[350px] md:h-[500px] lg:h-[688px]'>
            {/* Background Image */}
            <div className='absolute w-[120px] md:w-[160px] lg:w-[219px] h-[350px] md:h-[500px] lg:h-[620px] top-[60px] md:top-[100px] lg:top-[115px] right-[-15px] md:right-[-20px] lg:right-[-27px]'>
              <img
                src='./red.png'
                alt='Thumb 1'
                className='w-full h-full object-cover'
              />
            </div>

            {/* Main Image */}
            <img
              src='./qeen.png'
              alt='Thumb 1'
              className='absolute top-[30px] md:top-[80px] lg:top-[88px] left-[3px] md:left-[4px] lg:left-[6px] w-full h-full z-10 object-cover'
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section4;
